import { t } from 'i18next';
import { ageValidator } from "controller/ageValidator";

export const onInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  setSelectedDay: (value: string) => void,
  setSelectedMonth: (value: string) => void,
  setSelectedYear: (value: string) => void,
  setCon2: (value: boolean | ((prev: boolean) => boolean)) => void,
  setIsVarified: (value: boolean) => void,
  setFormValue: (value: any) => void,
  formValue: any,
  selectedDay: string,
  selectedMonth: string,
  selectedYear: string,
) => {

  const { name, value } = e.target;
  if (name === "selectedDay") {
    setSelectedDay(value);
  } else if (name === "selectedMonth") {
    setSelectedMonth(value);
  } else if (name === "selectedYear") {
    setSelectedYear(value);
  }
  if (name === "privacy-policy") {
    setCon2((prev: boolean) => !prev);
  }

  setIsVarified(false);
  setFormValue({ ...formValue, [name]: value });

  setFormValue((old) => {
    return {
      ...old,
      errors: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        gender: "",
        dob: "",
        referral: "",
        con2: "",
      },
    };
  });

  const regex = /^\S+(?:\s*\S+)*$/;
  // email validation patterns
  if (name === "email") {
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    // email validation
    if (!regexEmail.test(value.trim())) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, email: t("form.join.address") } };
      });
    } else if (!regex.test(value)) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, email: t("changePassword.error.blank") } };
      });
    } else {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, email: "" } };
      });
    }
  }
  // fName and lName validation

  if (name === "firstName" && value.length > 0) {
    if (value.length < 1) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, fname: t("form.join.First") } };
      });
    } else if (!regex.test(value)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, fname: t("changePassword.error.blank") },
        };
      });
    } else if (!/^[a-zA-Z]+$/.test(value.trim())) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, fname:  t("change.password.allowed") } };
      });
    }
  } else {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, fname: "" } };
    });
  }

  if (name === "lastName" && value.length > 0) {
    if (value.length < 1) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, lname: t("form.join.required") } };
      });
      return false;
    } else if (!regex.test(value)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, lname: t("changePassword.error.blank")},
        };
      });
      return false;
    } else if (!/^[a-zA-Z]+$/.test(value.trim())) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, lname:  t("change.password.allowed") } };
      });
      return false;
    }
    if (formValue.firstName.length < 1 || !regex.test(formValue.firstName)) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, fname: t("form.join.First") } };
      });
      return false;
    }
    if (!regex.test(formValue.firstName)) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, fname: t("changePassword.error.blank") } };
      });
      return false;
    }
    if (!/^[a-zA-Z]+$/.test(formValue.firstName.trim())) {
      setFormValue((old) => {
        return { ...old, errors: { ...old.errors, fname: t("change.password.allowed") } };
      });
      return false;
    }
  } else {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, lname: "" } };
    });
  }

  // password validation
  if (name === "password" || name === "confirmPassword") {
    if (
      formValue.password.length < 5 &&
      name === "confirmPassword" &&
      value.length > 0 &&
      regex.test(value)
    ) {
      setFormValue((old) => ({
        ...old,
        errors: { ...old.errors, password: t("change.password.create") },
      }));
    } else if (value.length < 6 && value.length > 0 && regex.test(value)) {
      setFormValue((old) => ({
        ...old,
        errors: { ...old.errors, password: t("form.join.passwordS") },
      }));
    } else if (!regex.test(value) && value.length > 0 && name === "password") {
      setFormValue((old) => ({
        ...old,
        errors: { ...old.errors, password: t("changePassword.error.blank") },
      }));
    } else if (!regex.test(value) && value.length > 0 && name === "confirmPassword") {
      setFormValue((old) => ({
        ...old,
        errors: { ...old.errors, confirmPassword: t("changePassword.error.blank") },
      }));
    } else {
      setFormValue((old) => ({
        ...old,
        errors: { ...old.errors, password: "", confirmPassword: "" },
      }));
    }
  }
  if (
    (name === "confirmPassword" || name === "password") &&
    formValue.password !== "" &&
    formValue.confirmPassword !== ""
  ) {
    if (value !== formValue.password && value.length > 5) {
      setFormValue((old) => ({
        ...old,
        errors: { ...old.errors, confirmPassword: t("change.password.match") },
      }));
    }
  }

  // gender validation

  if (name === "gender") {
    if (!value) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, gender: t("form.join.gender") },
        };
      });
    } else {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, gender: "" },
        };
      });
    }
  }
  const dayRegex = /^(0?[1-9]|[1-2][0-9]|3[0-1])$/;
  const monthRegex = /^(0?[1-9]|1[0-2])$/;
  const yearRegex = /^[0-9]{4}$/;

  if (name === "selectedDay") {
    if (!dayRegex.test(value)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.day")},
        };
      });
    } else if (!ageValidator(selectedYear, 13)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("form.join.underAgeError") },
        };
      });
    } else if (!monthRegex.test(selectedMonth)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.month") },
        };
      });
    } else if (!yearRegex.test(selectedYear)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.year") },
        };
      });
    }
  } else if (name === "selectedMonth") {
    if (!monthRegex.test(value)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.month") },
        };
      });
    } else if (!ageValidator(selectedYear, 13)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("form.join.underAgeError") },
        };
      });
    } else if (!yearRegex.test(selectedYear)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.year") },
        };
      });
    } else if (!dayRegex.test(selectedDay)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.day")},
        };
      });
    }
  } else if (name === "selectedYear") {
    if (!yearRegex.test(value)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.year") },
        };
      });
    } else if (!ageValidator(value, 13)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("form.join.underAgeError") },
        };
      });
    } else if (!monthRegex.test(selectedMonth)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.month") },
        };
      });
    } else if (!dayRegex.test(selectedDay)) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: t("change.password.day") },
        };
      });
    } else {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, dob: "" },
        };
      });
    }
  }
  if (name === "privacy-policy") {
    if (!value) {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, con2: t("form.join.accepts") },
        };
      });
    } else {
      setFormValue((old) => {
        return {
          ...old,
          errors: { ...old.errors, con2: "" },
        };
      });
    }
  }
};

export const handleOtp = (
  e: React.ChangeEvent<HTMLInputElement>,
  setOtp: (value: any) => void
) => {
  const value = e.target.value;
  const trimmedValue = value.replace(/\s+/g, "");
  const regex = /^\d*$/;

  if (regex.test(trimmedValue)) {
    setOtp(trimmedValue);
  }
};